<template>
  <div :class="[$style.notification, $style.trialEnding]">
    <div :class="[$style.main, { [$style.open]: moreDetailsVisible }]">
      <a :href="formatUrl(notification.url)" :class="$style.header" :target="linkTarget">
        <img :src="photoUrl(notification.team.photoUrl)" :title="notification.team.name" alt="" />
        <i class="fa fa-comment"></i>
        <span>{{ notification.title }}</span>
      </a>
      <span :class="$style.toggleMoreDetails" @click="toggleMoreDetails"><i class="fa fa-angle-left"></i></span>
      <span :class="$style.timer">{{ timer }}</span>
      <div :class="$style.moreDetails">
        <div :class="$style.moreDetailsInner">
          <h5>{{ notification.message }}</h5>
        </div>
      </div>
    </div>
    <a
      @click.prevent="readNotification(notification)"
      href="#"
      :class="$style.markAsRead"
      data-toggle="tooltip"
      data-placement="left"
      title="mark as read"></a>
  </div>
</template>

<script>
  import Notification from './notification'

  export default {
    mixins: [Notification],
    data () {
      return {
        moreDetailsVisible: true
      }
    }
  }
</script>

<style module lang="less" src="./notification.less"></style>



// WEBPACK FOOTER //
// trial-ending.vue?6022a681